import React from 'react';
import CourseHighlights from '../../Shared/Courses/CourseHighlights';
import CourseOperate from '../../Shared/Courses/CourseOperate';
import Cloud from '../../../img/Course-Elements/Cloud.png';

const AndroidDevelopment = () => {
    return (
        <div className='px-4 md:px-12 pt-10'>
            <h4 className='text-blue-500 text-xl'>Certified Online Course</h4>
            <h1 className='text-blue-500 text-4xl font-semibold my-4'>Android <span className='text-orange-400'>Development</span></h1>
            <h1 className='text-4xl font-semibold my-4'>Course @ Rs. 1199</h1>
            <h2 className=''>To create your own Zomato, Swiggy, Instagram, or other app, learn how to combine XML with Kotlin.</h2>
            <h3 className='text-xl my-4 font-semibold'>8 Weeks, 45 min /day (3 Recorded+2 Live)</h3>
            <h5>Offer: Get flat Rs.200 off oby applying the promo code CAREERHikers</h5>
            <h1 className='text-5xl mt-4 font-bold'>Download the</h1>
            <h1 className='text-5xl mt-2 text-orange-500 font-bold'><span className='text-blue-500'>APP</span> Now!</h1>
            <CourseHighlights />
            <div className='flex mb-8 mt-12'>
                <div className='flex-1 md:mr-4'>
                    <h1 className='text-3xl font-semibold mb-6'>Why learn how to develop Android apps?</h1>
                    <h2 className='text-xl my-2'>Popularity:</h2>
                    <p>Android App Development is one of the most in-demand skills right now, with 2.6 million apps available on the Play Store and 75 billion downloads annually.</p>
                    <h1 className='text-2xl my-2'>Create a custom app:</h1>
                    <h3>Consider having your name on an app on the Play Store. Nothing is more thrilling than that!</h3>
                    <h1 className='text-xl my-2'>a lucrative wage</h1>
                    <p className='text-sm'>According to Glassdoor, Android developers may make up to 9 LPA and more.</p>
                </div>
                <img className='flex-1' src={Cloud} alt="" />
            </div>
            <CourseOperate />
        </div>
    );
};

export default AndroidDevelopment;